import { Button, Grid, Paper, Box, Pagination } from "@mui/material";
import React from "react";
import { LessonTeachers } from "../../Api/OnlineLesson";
import { LessonTeacher } from "../../Objects/OnlineLesson";
import CategoryTitle from "../atoms/CategoryTitle";
import CustomerCard from "../molecules/CustomerCard";

export interface LessonTeacherListProps {
    lessonTeachers: LessonTeachers
    requestRegTeacher: () => void
    onClick: (lessonTeacher: LessonTeacher) => void
    onPageChange: (page: number) => void
}

const LessonTeacherList: React.FC<LessonTeacherListProps> = ({
    lessonTeachers,
    requestRegTeacher,
    onClick,
    onPageChange
}) => {
    return (
        <Paper>
            <CategoryTitle text="オンラインレッスン講師一覧" />
            <Box sx={{
                display: "flex",
                justifyContent: "right",
                margin: "14px"
            }}>
                <Button
                    onClick={() => {
                        requestRegTeacher()
                    }}
                >講師を登録する</Button>
            </Box>
            <Grid container sx={{ padding: "0 14px 14px 14px", marginTop: "14px" }} spacing={2}>
                {lessonTeachers.list.map(lessonTeacher => (
                    <Grid item key={lessonTeacher.teacher_id} xs={12} sm={6} md={4}>
                        {lessonTeacher.customerData &&
                            <CustomerCard customer={lessonTeacher.customerData} onClick={customer=>{
                                onClick(lessonTeacher)
                            }} />
                        }
                    </Grid>
                ))}
            </Grid>
            <Box sx={{
                padding: "10px",
                display: "flex",
                justifyContent: "center",
            }}>
                <Pagination count={lessonTeachers.pagenum} onChange={(e,page) =>{
                    onPageChange(page)
                }} variant="outlined" />
            </Box>
        </Paper>
    )
}

export default LessonTeacherList